import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import logo from "ASSETS/Images/img_header_logo.webp";
import "./WaitingScreen.less";
import { getMessage } from "CONFIG/i18n";
import {
  getIsOrganizer
} from "../CommonComponents/Header/selectors";

export class WaitingScreen extends Component {
  
  constructor(props){
    super(props);
    this.locationStateMessage = this.props.location ? this.props.location.state ? this.props.location.state.waitingScreenMessage : null : null;
  }

  getHeader = () => {
    return (
      <Row className="waitingHeader">
        <Col lg="8" md="8" xs="9" className="headerLogoContainer pl-0">
          <img className="logoHeader" src={logo} />
        </Col>
      </Row>
    );
  };
  render() {
 
    return (
      <div>
        <section className="bgColor">
          {!this.props.waitingScreenMessage && this.getHeader()}
          <Container>
            <Row>
              <Col
                md="12"
                lg="12"
                className={
                  !this.props.waitingScreenMessage
                    ? "text-center sessionEnded"
                    : ""
                }
              >
                <h4 className="topMargin text-center">

                  {this.locationStateMessage ? 
                    getMessage(this.locationStateMessage)
                    : this.props.waitingScreenMessage
                      ? this.props.waitingScreenMessage
                      : (this.props.isOrganizer 
                        ? getMessage("SESSION_ENDED") 
                        : getMessage("AGENT_HAS_ENDED_THE_SESSION"))}
                </h4>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isOrganizer: getIsOrganizer(state)
  };
};

export default connect(
  mapStateToProps,
  null
)(WaitingScreen);

